import { Pipe, PipeTransform } from '@angular/core';

import { NotificationCode } from '../models/communication/app-enums.model';

@Pipe({
    name: 'notificationText',
    standalone: true
})
export class NotificationTextPipe implements PipeTransform {
    transform(value?: NotificationCode): string {
        return NotificationTextPipe.codeToText(value);
    }

    static codeToText(code?: NotificationCode): string {
        switch (code) {
            case NotificationCode.AuthenticationFailed:
                return $localize`Authentication failed!`;
            case NotificationCode.AuthenticationSuccess:
                return $localize`Successfully authenticated!`;
            case NotificationCode.CroupierChangeInvalidState:
                return $localize`Croupier change not allowed in this game state.`;
            case NotificationCode.DuplicateCard:
                return $localize`Same round, same card detected.`;
            case NotificationCode.FlagFailed:
                return $localize`Flag failed, round not marked.`;
            case NotificationCode.InvalidCard:
                return $localize`Invalid card or card not recognized.`;
            case NotificationCode.InvalidCroupierId:
                return $localize`Invalid croupier ID for this table!`;
            case NotificationCode.ScannerDisconnected:
                return $localize`Card scanner is disconnected!`;
            case NotificationCode.ScannerConnected:
                return $localize`Card scanner is connected and ready.`;
            // Frontend only
            case NotificationCode.ActionFailed:
                return $localize`Action failed!`;
            case NotificationCode.CutCardDrawn:
                return $localize`Cut card drawn.`;
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown notification code: ${code}`);
                return String(code);
        }
    }
}
